import React from 'react';
import {View} from 'react-native';

import Locale from './../../Locale';
import {Layout, Navbar} from './../../Screen';
import {Form, Heading1, Button} from './../../Form';
import RPAScreen from './RPAScreen';
import IntroParagraph from './../components/IntroParagraph';
import ProductEdges from './../components/ProductEdges';
import PlanType from './../components/PlanType';
import DiscountInput from './../components/DiscountInput';
import LeafletAndProvision from './../components/LeafletAndProvision';

export default class RPAScreen1 extends RPAScreen {
  componentDidMount() {
    this.initialize();
  }

  render() {
    const {policy, rpa, payment} = this.state.insuranceProduct;

    let leaflet;
    switch (Locale.getLocale()) {
      case Locale.enUS:
        leaflet = 'Product_leaflet_Bravogo_eng.pdf';
        break;
      case Locale.zhHK:
        leaflet = 'Product_leaflet_Bravogo_chi.pdf';
        break;
    }

    const provision = 'Product_Provision_Bravogo.pdf';


    return (
      <Layout alert={this.state.alert} cardForm>
        <Navbar
          screen={this}
          title={Locale.text.getAQuote}
        />

        {Locale.text.bravoPassengerProtector}
        {Locale.text.bravoPassengerProtectorLeftPanel}

        <View style={Layout.container}>
          <Form>
            <Heading1>
              {Locale.text.bravoPassengerProtector}
            </Heading1>

            <IntroParagraph>
              {Locale.text.bravoPassengerProtectorIntroParagraph}
            </IntroParagraph>

            <ProductEdges>
              {Locale.text.bravoPassengerProtectorProductEdge1}
              {Locale.text.bravoPassengerProtectorProductEdge2}
              {Locale.text.bravoPassengerProtectorProductEdge3}
              {Locale.text.bravoPassengerProtectorProductEdge4}
            </ProductEdges>

            <View style={{marginTop: 10, marginBottom: 10, justifyContent: 'center', alignItems: 'center', textAlign: 'left'}}>
            <LeafletAndProvision
              screen={this}
              leaflet={leaflet}
              provision={provision}
            />
            </View>

            <PlanType
              options={this.premiumPlanOptions}
              value={rpa.premiumPlan}
              onChange={(premiumPlan) =>
                this.updateRPA({premiumPlan})}
            />

            <DiscountInput
              cozy
              promotionCode={payment.promotionCode}
              businessEmail={policy.businessEmail}
              directCustomer={this.state.initialized &&
                !this.state.agent && !this.state.broker}
              onChange={({promotionCode, businessEmail}) => {
                this.updatePayment({promotionCode});
                this.updatePolicy({businessEmail});
              }}
              messages={this.state.messages.discount}
            />

            <Button
              disabled={this.state.waiting}
              onPress={() => this.getQuote('RPA2')}
            >
              {Locale.text.getAQuote}
            </Button>
          </Form>
        </View>
      </Layout>
    );
  }
}
